import { render, staticRenderFns } from "./Estudante-habilitar-usuario.vue?vue&type=template&id=ed748388&scoped=true&"
import script from "./Estudante-habilitar-usuario.vue?vue&type=script&lang=js&"
export * from "./Estudante-habilitar-usuario.vue?vue&type=script&lang=js&"
import style0 from "./Estudante-habilitar-usuario.vue?vue&type=style&index=0&id=ed748388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed748388",
  null
  
)

export default component.exports